import React from "react"
import Iframe from "react-iframe"

import { Heading } from "./utils"

// Only neutral 3D-tour hosts are embedded. A partner's or developer's own
// website (one tour URL pointed at oneandonlyprivatehomesmauritius.com, another
// at serinavillas.com) would put their whole site, menu and contacts inside our
// page — the site never sends a buyer to a partner (rule of 20/10/2026).
const TOUR_HOSTS = /(^|\.)(matterport\.com|daneosltd\.com|kuula\.co|cloudpano\.com)$/i
const isNeutralTour = url => {
  try {
    return TOUR_HOSTS.test(new URL(String(url || "")).hostname)
  } catch {
    return false
  }
}

const VirtualTour = ({ virtualTour, global }) => (
  <>
    {virtualTour && isNeutralTour(virtualTour) && (
      <section className="container py-12 md:py-24">
        {global && (
          <Heading title={global.virtualTourTitle} className="mb-12" center />
        )}
        <div className="relative overflow-hidden transform translate-y-0 rounded-lg">
          <Iframe
            url={virtualTour}
            width="100%"
            height="100%"
            className="h-[90vh]"
            display="initial"
            position="relative"
          />
        </div>
      </section>
    )}
  </>
)

export default VirtualTour
